import React from "react";
import isFunction from "lodash/isFunction";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

import { ButtonValidation } from "./Button";

export default class ConfirmModal extends React.PureComponent {
  static defaultProps = {
    onRef: () => null
  };

  defaultState = {
    okText: "Ok",
    noText: "No",
    cancelText: "Cancel",
    title: "Untitled",
    content: "?",
    width: 520,
    zIndex: 1050,
    onOk: instance => null,
    onNo: instance => null,
    onCancel: instance => null,
    onClose: () => null,
    onConfirm: value => value,
    additional: null,
    cancelValue: null,
    isLoading: false,
    cancelable: false,
    visible: false,
    noValue: false,
    okValue: true,
    rejectable: true,
    mask: true,
    okButtonProps: {},
    noButtonProps: {},
    cancelButtonProps: {}
  };

  constructor(props) {
    super(props);

    this.state = { ...this.defaultState };
  }

  open = state => {
    this.setState({ ...state, visible: true });
  };

  close = () => {
    this.state.onClose();
    this.setState(this.defaultState);
  };

  toggleLoading = () => {
    this.setState({ isLoading: !this.state.isLoading });
  };

  setConfirm = res => {
    this.state.onConfirm(res);
    this.close();
  };

  okHandler = async () => {
    await this.state.onOk(this);
    this.setConfirm(this.state.okValue);
  };

  noHandler = async () => {
    await this.state.onNo(this);
    this.setConfirm(this.state.noValue);
  };

  cancelHandler = async () => {
    if (this.state.isLoading) return;
    
    await this.state.onCancel(this);
    this.setConfirm(this.state.cancelValue);
  };

  componentDidMount() {
    this.props.onRef(this);
  }

  componentWillUnmount() {
    this.props.onRef(undefined);
  }

  render() {
    const s = this.state;

    return (
      <Modal isOpen={s.visible} zIndex={s.zIndex} toggle={this.cancelHandler}>
        {s.title && (
          <ModalHeader toggle={this.cancelHandler}>{s.title}</ModalHeader>
        )}
        <ModalBody>
          {isFunction(s.content) ? s.content(this) : s.content}
        </ModalBody>
        <ModalFooter>
          {[
            <ButtonValidation
              color="primary"
              is_process={s.isLoading}
              {...s.okButtonProps}
              key="ok"
              onClick={this.okHandler}
            >
              {s.okText}
            </ButtonValidation>,
            s.rejectable ? (
              <ButtonValidation
                color="danger"
                is_process={s.isLoading}
                {...s.noButtonProps}
                key="no"
                onClick={this.noHandler}
              >
                {s.noText}
              </ButtonValidation>
            ) : null,
            s.cancelable ? (
              <ButtonValidation
                color="default"
                is_process={s.isLoading}
                {...s.cancelButtonProps}
                key="cancel"
                onClick={this.cancelHandler}
              >
                {s.cancelText}
              </ButtonValidation>
            ) : null,
            <div key="additional">
              {isFunction(s.additional) ? s.additional(this) : s.additional}
            </div>
          ]}
        </ModalFooter>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/component/Confirm.jsx